export const content = {
    name: "Uddhar Pujari",
    tagline: "Software Engineer",
    appVersion: "1.0.0",

    links: {
        github: "https://github.com/uddharpujari",
        linkedin: "https://www.linkedin.com/in/uddhar-pujari/",
        instagram: "https://www.instagram.com/uddharpujari",
        email: "pujariuddhar@gmail.com",
    },

    about: {
        intro: "I'm a software engineer living in Bengaluru.",
        currentWork: {
            text: "MBRDI",
            url: "https://www.mbrdi.co.in/",
        },
        bio: `When I'm not working, I'm likely emotionally invested in a Cricket match, over-analyzing a Formula 1 pit strategy, or pretending I'm going to finish the five books currently on my nightstand, or planning my next travel escape.`,
        interests: ["Cricket stats", "F1 Silly Season gossip"],
    },

    experience: [
        {
            role: "Software Engineer",
            company: "Mercedes Benz Research and Development India (MBRDI), Bengaluru",
            duration: "April 2023 — Present",
            description: "",
        },
        {
            role: "Graduate Engineer Trainee",
            company: "Mercedes Benz Research and Development India (MBRDI), Bengaluru",
            duration: "Aug 2022 — March 2023",
            description: "",
        },
        {
            role: "Intern",
            company: "Mercedes Benz Research and Development India (MBRDI), Bengaluru",
            duration: "March 2022 — July 2022",
            description: "",
        },
    ],

    education: [
        {
            degree: "Bachelor of Technology in Computer Science and Engineering",
            college: "PES University, Bengaluru",
            duration: "2018 — 2022",
        },
    ],
}
